document.addEventListener("DOMContentLoaded", function () {
    const filterButtons = document.querySelectorAll(".filter-btn");
    const partnerCards = [...document.querySelectorAll(".partner-card")];
    const grid = document.querySelector(".partners-grid");
    const currentDate = new Date();

    function sortPartners() {
        const activePartners = partnerCards.filter(card => {
            const offerEndDate = new Date(card.dataset.offerEndDate.replace(/-/g, '/'));
            return offerEndDate >= currentDate;
        }).sort((a, b) => new Date(a.dataset.offerEndDate.replace(/-/g, '/')) - new Date(b.dataset.offerEndDate.replace(/-/g, '/')));

        const expiredPartners = partnerCards.filter(card => {
            const offerEndDate = new Date(card.dataset.offerEndDate.replace(/-/g, '/'));
            return offerEndDate < currentDate;
        });

        return [...activePartners, ...expiredPartners]; // Expired stay at bottom
    }

    function updateFilterCounts() {
        const categoryCounts = {};
        let activeCount = 0; // For 'All' counter (Only counts active partners)

        partnerCards.forEach(card => {
            const category = card.dataset.category;
            const offerEndDate = new Date(card.dataset.offerEndDate.replace(/-/g, '/'));
            const isActive = offerEndDate >= currentDate;

            if (isActive) {
                categoryCounts[category] = (categoryCounts[category] || 0) + 1;
                activeCount++; // Only count active partners
            }
        });

        filterButtons.forEach(button => {
            const category = button.getAttribute("data-filter");
            if (category === "all") {
                button.querySelector(".count").textContent = `(${activeCount})`; // FIXED: Only active partners counted
            } else {
                button.querySelector(".count").textContent = categoryCounts[category] ? `(${categoryCounts[category]})` : "(0)";
            }
        });
    }

    function renderPartners(filter) {
        const sortedPartners = sortPartners();
        grid.innerHTML = "";

        sortedPartners.forEach(partner => {
            const category = partner.dataset.category;
            const offerEndDate = new Date(partner.dataset.offerEndDate.replace(/-/g, '/'));
            const isActive = offerEndDate >= currentDate;

            if (filter === "all") {
                partner.style.display = "block"; // Show all (active + expired at bottom)
            } else {
                partner.style.display = category === filter ? "block" : "none";
            }
            grid.appendChild(partner);
        });

        updateFilterCounts();
    }

    filterButtons.forEach(button => {
        button.addEventListener("click", function () {
            filterButtons.forEach(btn => btn.classList.remove("active"));
            button.classList.add("active");
            renderPartners(button.getAttribute("data-filter"));
        });
    });

    renderPartners("all");
});